import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import ManagedInput from 'components/form/managed_input';
import { USD } from 'helpers/formatters/number_formats';

export function TierRow({ canEdit, index, isLast, tier, onChange }) {
  const handleChange = (changes) => {
    onChange({ ...tier, ...changes }, index);
  };

  return (
    <tr>
      <td className="bg-light">Tier {index + 1}</td>
      <td className="numeric bg-light">{USD.format(tier.from, { round: true })}</td>
      <td className={classNames('numeric', { 'bg-light': isLast || !canEdit })}>
        {(canEdit && isLast) || (!canEdit && !tier.to) ? <span>Unlimited</span> :
          <ManagedInput
            disabled={!canEdit}
            name="to"
            precision={0}
            type="currency"
            value={tier.to}
            onChange={handleChange}
          />
        }
      </td>
      <td className={classNames('numeric', { 'bg-light': !canEdit })}>
        <ManagedInput
          disabled={!canEdit}
          name="royaltyPercentage"
          type="number"
          value={tier.royaltyPercentage}
          onChange={handleChange}
        />
      </td>
    </tr>
  );
}

TierRow.propTypes = {
  canEdit: PropTypes.bool,
  index: PropTypes.number.isRequired,
  isLast: PropTypes.bool,
  tier: PropTypes.shape({
    from: PropTypes.number,
    royaltyPercentage: PropTypes.number,
    to: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TierRow;
